(function () {
    'use strict';

    angular.module('fundSwapApp').controller('FundSwapController',
        FundSwapController);

    FundSwapController.$inject = ['$scope', 'entity', '$window', 'FundSwapService',
        'CommonService', 'FileNetService', '$http', '$uibModal', '$log',
        '$base64', 'Upload', 'authExpiredInterceptor', 'AlertService',
        '$stateParams', '$state', 'CONST_COMMON'];

    function FundSwapController($scope, entity, $window, FundSwapService,
                                CommonService, FileNetService, $http, $uibModal, $log, $base64,
                                Upload, authExpiredInterceptor, AlertService, $stateParams, $state,
                                CONST_COMMON) {
        var fundSwapCtr = this;
        $scope.loading = false;
        var self = $scope;
        self.isDisable = false;
        fundSwapCtr.listFund = [];
        fundSwapCtr.listFundEstValueGTZero = [];
        fundSwapCtr.fund = {};
        fundSwapCtr.fundFilters = [];
        fundSwapCtr.listFundSwap = [];
        fundSwapCtr.validPolicy = false;
        self.inValidFundSwap1 = false;
        self.inValidFundSwap2 = false;
        self.flag = false;
        fundSwapCtr.files = [];
        self.isCheckSignature = false;
        self.isInValidChoiceValue = false;
        fundSwapCtr.archiveDataIdsDelete = [];
        if ($stateParams.taskId != undefined && $stateParams.taskId != '') {
            self.taskInstanceId = $base64.decode($stateParams.taskId);
        }
        fundSwapCtr.changeFund = function () {
            fundSwapCtr.fund.virtualFund = null;
            if (fundSwapCtr.fund.fundType === 'ONE') {
                $state.go('fund-swap.one');
                fundSwapCtr.fund.percent = null;
                //filter estimated Value
                fundSwapCtr.listFundEstValueGTZero = fundSwapCtr.fund.listFundSwap.filter(function (i) {
                    return i.estimateValue > 0 && i.type === 'C';
                });
                fundSwapCtr.fundFilters = fundSwapCtr.fund.listFundSwap.filter(function (i) {
                    return i.type === 'P';
                });
            } else if (fundSwapCtr.fund.fundType === 'MANY') {
                $state.go('fund-swap.many');
                //filter estimated Value
                fundSwapCtr.listFundEstValueGTZero = fundSwapCtr.fund.listFundSwap.filter(function (i) {
                    return i.type === 'P';
                });
                fundSwapCtr.fundFilters = fundSwapCtr.fund.listFundSwap.filter(function (i) {
                    return i.estimateValue > 0 && i.type === 'C';
                });
                fundSwapCtr.fund.percent = 100;
            }
        }

        fundSwapCtr.fund = {};
        fundSwapCtr.init = function () {
            if (entity != null) {
                self.isDisable = true;
                entity.taskInstanceId = self.taskInstanceId;
                fundSwapCtr.fund = entity;
                fundSwapCtr.validPolicy = true;
                fundSwapCtr.listFundEstValueGTZero = [{
                    fundName: entity.fundName,
                    virtualFund: entity.virtualFund
                }];
                fundSwapCtr.fundFilters = entity.listFundSwap;
                fundSwapCtr.fundFilters.forEach(function (e) {
                    e.checked = true;
                });
                fundSwapCtr.getTotalFundSwapForManyType();
                var obj = {
                    'file': entity.archiveDataId,
                    'archiveDataId': 1
                }
                fundSwapCtr.files.push(obj);
                if (fundSwapCtr.fund.fundType === 'ONE') {
                    $state.go('fund-swap.one');
                } else if (fundSwapCtr.fund.fundType === 'MANY') {
                    $state.go('fund-swap.many');
                }
            } else {
                var fund = {
                    checked: false,
                    percent: null
                };
                fundSwapCtr.listFund[0] = fund;
            }
        };

        fundSwapCtr.checkSignature = function () {
            self.isCheckSignature = true;
            if (fundSwapCtr.fund.policyNum == undefined
                || fundSwapCtr.fund.policyNum == null)
                return false;
            $scope.loading = true;
            FileNetService
                .query(
                    {
                        method: 'get-list-poldoc',
                        polNum: fundSwapCtr.fund.policyNum
                    },
                    function (result) {
                        if (result.length > 0) {
                            $scope.loading = false;
                            fundSwapCtr.animationsEnabled = true;
                            var modalInstance =
                                // show dialog
                                $uibModal
                                    .open({
                                        animation: fundSwapCtr.animationsEnabled,
                                        templateUrl: GLOBAL_URL
                                            + 'partial?uri=ga/signature/signature-dialog',
                                        controller: 'SignatureDialogController as signatureDlgCtrl',
                                        size: 'lg',
                                        resolve: {
                                            items: function () {
                                                return result;// tranfer
                                                // data
                                                // for
                                                // dialog
                                            }
                                        }
                                    });
                            modalInstance.result.then(function (result) {
                                $scope.loading = false;
                            }, function (error) {
                                $scope.loading = false;
                            });
                        } else {
                            $scope.loading = false;
                            $scope
                                .addAlert(
                                    'File chữ ký HD ['
                                    + fundSwapCtr.fund.policyNum
                                    + '] không tồn tại.Vui lòng kiểm tra lại',
                                    'warning');
                        }
                    }, function (error) {
                        $scope.loading = false;
                    });
        };
        fundSwapCtr.checkPORedFlaClient = function (policyNum) {
            FundSwapService.returnValue({
                uri: 'check-PO-red-flag-client',
                policyNum: policyNum
            }, function (result) {
                if (result.response === 'true') {
                    $scope.addAlert("PO bị cài code red flag client (WAN,SAN..). Vui lòng liên hệ GAM hỗ trợ", "danger")
                }
            }, function (error) {
                self.loading = false;
            });
        }

        fundSwapCtr.findPolicy = function () {
            $scope.loading = true;
            if (fundSwapCtr.fund.policyNum == null
                || fundSwapCtr.fund.policyNum == undefined) {
                $scope.addAlert('Vui lòng nhập số hợp đồng.', 'warning');
                $scope.loading = false;
            } else {
                FundSwapService.get({
                        uri: 'getByPolicynum',
                        policyNum: fundSwapCtr.fund.policyNum
                    }, function (result) {
                        $scope.loading = false;
                        fundSwapCtr.fund = result;
                        //init one layout
                        fundSwapCtr.fund.fundType = 'ONE';
                        $state.go('fund-swap.one');
                        fundSwapCtr.validPolicy = true;

                        fundSwapCtr.listFund = fundSwapCtr.fund.listFundSwap;
                        fundSwapCtr.fundFilters = fundSwapCtr.fund.listFundSwap.filter(function (i) {
                            return i.type === 'P';
                        });
                        //filter estimated Value
                        fundSwapCtr.listFundEstValueGTZero = fundSwapCtr.fund.listFundSwap.filter(function (i) {
                            return i.estimateValue > 0 && i.type === 'C';
                        });
                        fundSwapCtr.checkPORedFlaClient(fundSwapCtr.fund.policyNum);
                    },
                    function () {
                        self.loading = false;
                    });
            }
        };

        fundSwapCtr.renderBaseOrInvestFund = function (fundId, type) {
            var key = fundId.slice(fundId.length - 1);
            if (type === 'ONE') {
                fundSwapCtr.fundFilters = fundSwapCtr.listFund.filter(function (item) {
                    return item.virtualFund.endsWith(key) && item.virtualFund !== fundId && item.type === 'P';
                });
                //reset value
                fundSwapCtr.fund.fundSwapValue = null;
                fundSwapCtr.fund.percent = null;
                // fundSwapCtr.fund.fundSwapValue = fundSwapCtr.listFund.find(function (item) {
                //     return item.virtualFund === fundId;
                // }).estimateValue;
            } else if (type === 'MANY') {
                fundSwapCtr.fund.virtualFund = null;
                var fundRemoves = null;
                var fund1 = fundSwapCtr.fundFilters.filter(function (f) {
                    return f.checked && f.virtualFund.endsWith('1');
                });
                var fund2 = fundSwapCtr.fundFilters.filter(function (f) {
                    return f.checked && f.virtualFund.endsWith('2');
                });
                if (fund1.length > 0 && fund2.length > 0) {
                    self.isInValidChoiceValue = true;
                    self.addAlert("Chỉ chọn nhóm quỹ tài khoản cơ bản hoặc nhóm quỹ tài khoản đầu tư thêm.", "danger");
                    return;
                }
                self.isInValidChoiceValue = false;
                if (fund1.length == 0 && fund2.length == 0) {
                    fundSwapCtr.listFundEstValueGTZero = fundSwapCtr.listFund.filter(function (item) {
                        return item.type === 'P';
                    });
                    return;
                } else if (fund1.length > 0) {
                    key = '1';
                    fundRemoves = fund1;
                } else if (fund2.length > 0) {
                    key = '2';
                    fundRemoves = fund2;
                }
                var removeCodes = [];
                if (fundRemoves != null) {
                    fundRemoves.forEach(function (f) {
                        removeCodes.push(f.virtualFund);
                    });
                }
                fundSwapCtr.listFundEstValueGTZero = fundSwapCtr.listFund.filter(function (item) {
                    return item.type === 'P' && item.virtualFund.endsWith(key) && !removeCodes.includes(item.virtualFund);
                });
            }
        };

        fundSwapCtr.getTotalFundSwap = function (index) {
            var total = 0;
            if (fundSwapCtr.fundFilters.length > 0) {
                fundSwapCtr.fundFilters.forEach(function (item) {
                    if (item.checked && item.fundSwapValue != null) {
                        total += item.fundSwapValue;
                    }
                });
            }
            var currentFund = fundSwapCtr.fundFilters[index];
            if (!currentFund.checked) {
                fundSwapCtr.fundFilters[index].fundSwapValue = null;
                fundSwapCtr.fundFilters[index].percent = null;
            }
            fundSwapCtr.fund.totalFundSwap = Math.round(total);
        };

        fundSwapCtr.getTotalFundSwapForManyType = function () {
            var sum = 0;
            fundSwapCtr.fundFilters.forEach(function (e) {
                if (e.checked) {
                    sum += e.fundSwapValue;
                }
            });
            fundSwapCtr.fund.totalFundSwap = Math.round(sum);
        }

        fundSwapCtr.countFundValue = function (index) {
            var currentFund = fundSwapCtr.fundFilters[index];
            if (currentFund.checked) {
                if (currentFund.percent != null) {
                    fundSwapCtr.fundFilters[index].fundSwapValue = Math.round((currentFund.percent * currentFund.estimateValue) / 100);
                }
            }
            fundSwapCtr.getTotalFundSwap(index);
        };

        fundSwapCtr.checkConsiderContractByOne = function (virtualFund) {
            if (virtualFund != null && fundSwapCtr.fund.fundSwapValue != null) {
                $scope.clearMessage();
                if (fundSwapCtr.fund.considerContract && fundSwapCtr.fund.fundSwapValue < 1000000) {
                    self.addAlert('Số tiền hoán đổi phải lớn hơn hoặc bằng 1,000,000VNĐ.', 'danger');
                    self.inValidFundSwap1 = true;
                } else self.inValidFundSwap1 = false;

                var currentFund = fundSwapCtr.listFundEstValueGTZero.find(function (item) {
                    return item.virtualFund === virtualFund;
                });
                if (fundSwapCtr.fund.considerContract && fundSwapCtr.fund.fundSwapValue !== Math.round(currentFund.estimateValue) && (Math.round(currentFund.estimateValue) - fundSwapCtr.fund.fundSwapValue) < 1000000) {
                    self.addAlert('Số tiền quỹ còn lại nhỏ hơn 1,000,000VNĐ. Yêu cầu khách hàng hoán đổi toàn bộ số tiền hoặc số tiền quỹ còn lại phải lớn hơn hoặc bằng 1,000,000VNĐ.', 'danger');
                    self.inValidFundSwap2 = true;
                } else self.inValidFundSwap2 = false;
            }
        };

        fundSwapCtr.checkConsiderContractByMany = function (index) {
            var currentFund = fundSwapCtr.fundFilters[index];
            if (currentFund.fundSwapValue != null) {
                $scope.clearMessage();
                if (fundSwapCtr.fund.considerContract && currentFund.fundSwapValue < 1000000) {
                    self.addAlert('Số tiền hoán đổi phải lớn hơn hoặc bằng 1,000,000VNĐ.', 'danger');
                    self.inValidFundSwap1 = true;
                } else self.inValidFundSwap1 = false;

                if (currentFund.fundSwapValue !== Math.round(currentFund.estimateValue) && fundSwapCtr.fund.considerContract && (Math.round(currentFund.estimateValue) - currentFund.fundSwapValue) < 1000000) {
                    self.addAlert('Số tiền quỹ còn lại nhỏ hơn 1,000,000VNĐ. Yêu cầu khách hàng hoán đổi toàn bộ số tiền hoặc số tiền quỹ còn lại phải lớn hơn hoặc bằng 1,000,000VNĐ.', 'danger');
                    self.inValidFundSwap2 = true;
                } else self.inValidFundSwap2 = false;
            }
        };

        fundSwapCtr.countFundValueByOne = function () {
            if (fundSwapCtr.fund.virtualFund != null) {
                var currentEstimateValue = fundSwapCtr.listFundEstValueGTZero.find(function (item) {
                    return item.virtualFund === fundSwapCtr.fund.virtualFund;
                }).estimateValue;
                if (fundSwapCtr.fund.percent != null)
                    fundSwapCtr.fund.fundSwapValue = Math.round((fundSwapCtr.fund.percent * currentEstimateValue) / 100);
                else fundSwapCtr.fund.fundSwapValue = null;
            }
        };

        fundSwapCtr.countFundValueWithOneType = function (index) {
            var currentFund = fundSwapCtr.fundFilters[index];
            //var totalFundSend = (fundSwapCtr.fund.fundSwapValue * fundSwapCtr.fund.percent) / 100;
            if (currentFund.checked) {
                if (currentFund.percent != null)
                    fundSwapCtr.fundFilters[index].fundSwapValue = (currentFund.percent * fundSwapCtr.fund.fundSwapValue) / 100;
                else fundSwapCtr.fundFilters[index].fundSwapValue = null;
            } else {
                currentFund.percent = null;
            }
        };

        $scope.$watch('fundSwapCtr.file', function () {
            fundSwapCtr.chooseUploadFiles(fundSwapCtr.file);
        });

        fundSwapCtr.chooseUploadFiles = function (file) {
            if (file) {
                $scope.clearMessage();
                var obj = {
                    'file': file,
                    'archiveDataId': 0
                }
                if (fundSwapCtr.files.length > 1)
                    self.addAlert('Tối đa chỉ được đính kèm 1 file.', 'danger');
                else
                    fundSwapCtr.files.push(obj);
                fundSwapCtr.file = null;
            }
        };

        fundSwapCtr.removeFile = function (index) {
            fundSwapCtr.archiveDataIdsDelete
                .push(fundSwapCtr.files[index].file.archiveDataId);
            //self.requestAdvance.filesRemove = fundSwapCtr.archiveDataIdsDelete;
            fundSwapCtr.files.splice(index, 1);
        };

        fundSwapCtr.transactionURLs = CommonService.query({masterurl: 'get-transaction-url'});
        fundSwapCtr.getTransactionURL = function (code) {
            return _.result(_.find(fundSwapCtr.transactionURLs, function (obj) {
                return obj.code === code;
            }), 'name');
        };

        fundSwapCtr.release = function () {
            self.loading = true;
            self.clearMessage();
            FundSwapService.post({uri: 'do-release'}, fundSwapCtr.fund, function (result) {
                if (result) {
                    self.loading = false;
                    window.open(fundSwapCtr.getTransactionURL('TRANSACTION_MAIN') + '/task#/common-task','_self');
                }
            }, function (error) {
            });
        };


        // cancel transaction
        fundSwapCtr.cancelReason = function () {
            fundSwapCtr.animationsEnabled = true;
            var modalInstance =
                //show dialog
                $uibModal.open({
                    animation: fundSwapCtr.animationsEnabled,
                    templateUrl: GLOBAL_URL + 'partial?uri=ga/fund-swap/layouts/fund-swap-cancel-reason-dialog',
                    controller: 'FundSwapCancelDialogController as cancelReasonDlgCtr',
                    size: 'lg',
                    resolve: {
                        fundSwap: function () {
                            return fundSwapCtr.fund;
                        }
                    }
                });
            modalInstance.result.then(
                function (result) {
                    fundSwapCtr.fund = result;
                    fundSwapCtr.getTotalFundSwapForManyType();
                },
                function (error) {

                });
        };

        fundSwapCtr.reset = function () {
            self.isDisable = false;
            self.clearMessage();
            $state.transitionTo($state.current, {}, {
                reload: true, inherit: false, notify: true
            });
        };

        fundSwapCtr.send = function () {
            if (!self.isCheckSignature && !self.flag) {
                self.loading = false;
                $scope.addAlert("Nhân viên kiểm tra chữ ký khách hàng trước khi thực hiện Gửi duyệt.", "warning");
                if (!self.flag) {
                    self.flag = true;
                    return;
                }
            }
            ;

            if (self.isInValidChoiceValue) {
                self.addAlert("Chỉ chọn nhóm quỹ tài khoản cơ bản hoặc nhóm quỹ tài khoản đầu tư thêm.", "danger");
                return;
            }
            ;

            if (self.inValidFundSwap1) {
                self.addAlert('Số tiền hoán đổi phải lớn hơn hoặc bằng 1,000,000VNĐ.', 'danger');
                return;
            }
            ;

            if (self.inValidFundSwap2) {
                self.addAlert('Số tiền quỹ còn lại nhỏ hơn 1,000,000VNĐ. Yêu cầu khách hàng hoán đổi toàn bộ số tiền hoặc số tiền quỹ còn lại phải lớn hơn hoặc bằng 1,000,000VNĐ.', 'danger');
                return;
            }
            ;

            var haveError = false;
            var totalPercent = 0;
            var j = 0;
            fundSwapCtr.fund.listFundSwap = [];
            for (var i = 0; i < fundSwapCtr.fundFilters.length; i++) {
                var fundTemp = fundSwapCtr.fundFilters[i];
                if (fundTemp.checked) {
                    totalPercent += fundTemp.percent;
                    fundSwapCtr.fund.listFundSwap[j] = fundTemp;
                    j++;
                }
            }
            if (totalPercent != 100 && fundSwapCtr.fund.fundType === 'ONE') {
                self.addAlert('Tổng tỷ lệ đầu tư phải bằng 100', 'warning');
                haveError = true;
            }

            if (!haveError) {
                var data = [];
                self.loading = true;

                if (fundSwapCtr.files) {
                    for (var int = 0; int < fundSwapCtr.files.length; int++) {
                        var array_element = fundSwapCtr.files[int];
                        data['fileFundSwap' + int] = array_element;
                    }
                }
                data['fundSwap'] = new Blob(
                    [JSON.stringify(fundSwapCtr.fund)], {
                        type: "application/json"
                    });
                Upload.upload(
                    {
                        url: GLOBAL_URL
                            + 'api/ga/fund-swap/do-save?access_token='
                            + authExpiredInterceptor.getToken(),
                        data: data
                    }).then(function (resp) {
                    self.loading = false;
                    if (resp.data.fundSwapId) {
                        self.isDisable = true;
                        fundSwapCtr.fund = resp.data;
                        fundSwapCtr.getTotalFundSwapForManyType();

                    }
                }, function (evt) {

                });
            }
        };

        fundSwapCtr.doSendLas = function () {
            self.loading = true;
            self.clearMessage();

            FundSwapService.post({uri: 'do-send-to-las'}, fundSwapCtr.fund, function (result) {
                self.loading = false;
                fundSwapCtr.fund = result;
                fundSwapCtr.getTotalFundSwapForManyType();
            }, function (error) {
                self.loading = false;
                // if (error != null) fundSwapCtr.fund = error.data;
                //self.addAlert("Lỗi hoán đổi quỹ trên LAS. Vui lòng thực hiện lại.", "danger");
            });
        }
    }

})();
